import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.css";
import App from "./App";
import "./App.css";

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
